import { RootState } from "../RootReducer";
import { ISettingsState } from "./ActionTypes";

export const SettingsLoading = (state: RootState): boolean => state.settings.loading;
export const DefaultFilters = (state: RootState): string[] => state.settings.defaultFilters;
export const DefaultEventCategories = (state: RootState): string[] => state.settings.defaultEventCategories;
export const Settings = (state: RootState): ISettingsState => state.settings;
export const MarkerIsLiveHours = (state: RootState): number => state.settings.markerIsLiveHours;
export const SettingsErrors = (state: RootState): string | undefined => state.settings.error;
export const AdminSettingsLoading = (state: RootState): boolean => state.settings.settingsLoading;
export const AdminSettingsErrors = (state: RootState): string | undefined => state.settings.settingsError;
